import { Grid } from '@mui/material';
import DoughnutChart from './DoughnutChart';
import PortfolioCompositionList from './PortfolioCompositionList';
import { useGetPortfolioCompositionData } from './useGetPortfolioCompositionData';
import { MarketPortfolioTenure, useMarketPortfolioData } from './useMarketPortfolioData';
import { Typography } from '../../atoms/Typography/Typography';

const PortfolioCompositionContainer = ({
    recommendedPortfolioId,
    allMarketPortfolios,
    tenure
}: {
    recommendedPortfolioId: number;
    allMarketPortfolios: Array<any>;
    tenure?: MarketPortfolioTenure;
}) => {
    // Select the correct source for composition (tactical if available, otherwise strategic)
    const { portfolioCompositionSource } = useMarketPortfolioData(tenure);
    const { doughnutChartData, groupedPortfolio, recommendedPortfolioName } = useGetPortfolioCompositionData(
        recommendedPortfolioId,
        portfolioCompositionSource.length ? portfolioCompositionSource : allMarketPortfolios
    );
    return (
        <>
            <Grid item xs={12} mt={1} mb={3}>
                <Typography label={recommendedPortfolioName} variant="headers.h2" />
            </Grid>
            <Grid container item direction="row" xs={12} spacing={1} mb={3}>
                <Grid item xs={4}>
                    <DoughnutChart doughnutChartData={doughnutChartData} groupedPortfolio={groupedPortfolio} />
                </Grid>
                <Grid item xs={8}>
                    <PortfolioCompositionList portfolioListData={groupedPortfolio} />
                </Grid>
            </Grid>
        </>
    );
};

export default PortfolioCompositionContainer;
